module.exports = __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmEU9fBxc4AMP6lbBP.fa61c0e4.woff2";